import { Grid } from './types';

const TEMPLATE_0: Grid = [[]];

const TEMPLATE_1: Grid = [[3]];

const TEMPLATE_2: Grid = [[1, 2]];

const TEMPLATE_3: Grid = [[1, 1, 1]];

const TEMPLATE_4: Grid = [[1, 2, 1, 2]];

const TEMPLATE_5: Grid = [
  [2, 2],
  [1, 2, 1],
];

const TEMPLATE_6: Grid = [
  [1.5, 1, 1.5],
  [1, 2, 1],
];

const TEMPLATE_7: Grid = [
  [1.5, 2, 1, 1.5],
  [2, 2, 2],
];

const TEMPLATE_8: Grid = [
  [1.5, 2, 1, 1.5],
  [1, 2, 2, 1],
];

const TEMPLATE_9: Grid = [
  [1.5, 1, 1.5],
  [1, 2, 1],
  [1.5, 1, 1.5],
];

const TEMPLATE_10: Grid = [
  [1.5, 2, 1.5],
  [2, 1, 2],
  [1, 1.5, 1, 1.5],
];

const TEMPLATE_11: Grid = [
  [1.5, 2, 1, 1.5],
  [1, 2, 2, 1],
  [2, 2, 2],
];

const TEMPLATE_12: Grid = [
  [1.5, 2, 1, 1.5],
  [1, 2, 2, 1],
  [1.5, 2, 1, 1.5],
];

const TEMPLATE_13: Grid = [
  [1.5, 2, 1, 1.5, 1],
  [2, 2, 1, 2],
  [1.5, 2, 2, 1.5],
];

const TEMPLATE_14: Grid = [
  [1.5, 2, 1, 1.5, 1],
  [2, 2, 1, 2],
  [1.5, 1, 2, 1, 1.5],
];

const TEMPLATE_15: Grid = [
  [1.5, 2, 1.5, 1, 2],
  [2, 2, 1.5, 1, 1.5],
  [1.5, 2, 1, 1.5, 2],
];

const TEMPLATE_16: Grid = [
  [1.5, 2, 1, 1.5, 1, 1],
  [2, 2, 1.5, 1, 1.5],
  [1.5, 2, 1, 1.5, 2],
];

const TEMPLATE_17: Grid = [
  [2, 1.5, 2, 1, 1, 1.5],
  [1.5, 1, 2, 1.5, 2, 1],
  [2, 2, 1.5, 1.5, 2],
];

const TEMPLATE_18: Grid = [
  [2, 2, 1, 1, 1.5, 1.5],
  [1.5, 2, 1, 2, 1.5, 1],
  [1, 2, 1, 1.5, 1.5, 2],
];

const TEMPLATE_19: Grid = [
  [1.5, 2, 1.5, 1.5, 2, 1.5],
  [2, 1, 1.5, 1, 1.5, 1, 2],
  [1.5, 2, 1.5, 1.5, 2, 1.5],
];

const TEMPLATE_20: Grid = [
  [1.5, 2, 1.5, 1.5, 2, 1.5],
  [2, 1, 1.5, 1, 1.5, 1, 2],
  [1, 1.5, 1.5, 2, 1.5, 1.5, 1],
];

export const TEMPLATES = [
  TEMPLATE_0,
  TEMPLATE_1,
  TEMPLATE_2,
  TEMPLATE_3,
  TEMPLATE_4,
  TEMPLATE_5,
  TEMPLATE_6,
  TEMPLATE_7,
  TEMPLATE_8,
  TEMPLATE_9,
  TEMPLATE_10,
  TEMPLATE_11,
  TEMPLATE_12,
  TEMPLATE_13,
  TEMPLATE_14,
  TEMPLATE_15,
  TEMPLATE_16,
  TEMPLATE_17,
  TEMPLATE_18,
  TEMPLATE_19,
  TEMPLATE_20,
];
